import React from 'react';
import Helmet from 'react-helmet';

const handleRedirect = ({ url, license }) => {
  const partner_name = url
    ? url
    : license
      ? `qp_${license}`
      : window.location.origin + window.location.pathname;

  window.location.href = `https://www.livechatinc.com/powered-by-livechat/?utm_source=quality_page_redir&utm_medium=referral&utm_campaign=${partner_name}`;
};

const RedirectToPBL = props =>
  <div>
    <Helmet
      title={`Service Quality Page`}
      meta={[
        { name: 'robots', content: 'noindex,nofollow' },
        {
          name: 'description',
          content:
            'A quality page is a customer service quality check which is based on metrics like customer satisfaction and chat availability.'
        }
      ]}
    />

    {handleRedirect(props)}
  </div>;

export default RedirectToPBL;



// WEBPACK FOOTER //
// ./src/components/RedirectToPBL.js